/**
 * Per-wallet "approvals already signed" flag.
 *
 * Backend's `setup-approvals` endpoint always returns the full 10-call batch
 * (it doesn't probe current allowances), so we can't ask the API "is this
 * wallet already approved?". Until that exists, we cache the success
 * client-side keyed by deposit-wallet address — that's enough to hide the
 * Approvals CTA on Home after the user signs it once.
 */
const STORAGE_PREFIX = 'torian.approvals.';

function safeStorage(): Storage | null {
  try {
    return typeof window === 'undefined' ? null : window.localStorage;
  } catch {
    return null;
  }
}

export function markApprovalsDone(walletAddress: string): void {
  const s = safeStorage();
  if (!s || !walletAddress) return;
  try {
    s.setItem(`${STORAGE_PREFIX}${walletAddress.toLowerCase()}`, String(Date.now()));
  } catch {
    /* quota or disabled storage — ignore */
  }
}

export function hasApprovalsDone(walletAddress: string | null | undefined): boolean {
  const s = safeStorage();
  if (!s || !walletAddress) return false;
  try {
    return s.getItem(`${STORAGE_PREFIX}${walletAddress.toLowerCase()}`) != null;
  } catch {
    return false;
  }
}
